export default {
  common: {
    error: "Une erreur s'est produite",
    reload: "Recharger",
    errorNotification: "Nous avons été notifiés et nous le corrigerons dès que possible. Si le problème persiste, veuillez",
    contactUs: "nous contacter.",
    language: "Langue",
    loading: "Chargement...",
    loadingText: "Chargement",
    save: "Enregistrer",
    savedSuccessfully: "Enregistré avec Succès",
    saving: "Enregistrement...",
    cancel: "Annuler",
    edit: "Modifier",
    delete: "Supprimer",
    add: "Ajouter",
    search: "Rechercher",
    filter: "Filtrer",
    clear: "Effacer",
    preview: "Aperçu",
    default: "Par défaut : {{value}}",
    optional: "Optionnel",
    required: "Requis",
    noData: "Aucune donnée",
  },
  // Places navigation
    places: {
    navigation: {
      locations: "Emplacements",
      cities: "Villes", 
      regions: "Régions",
      countries: "Pays",
      showOnMap: "Afficher sur la carte",
      addLocation: "Ajouter un emplacement"
    },
    welcome: {
      title: "Bienvenue sur Locations So Super.",
      subtitle: "Sélectionnez une section dans la navigation pour commencer."
    }
  },

  // Cities section
    cities: {
    title: "Villes",
    resourceSingular: "ville",
    resourcePlural: "villes",
    headings: {
      name: "Nom",
      status: "Statut",
      locations: "Emplacements", 
      region: "Région",
      country: "Pays"
    },
    breadcrumbs: {
      cities: "Villes"
    }
  },

  // Countries section
    countries: {
    title: "Pays",
    resourceSingular: "pays", 
    resourcePlural: "pays",
    headings: {
      name: "Nom",
      status: "Statut",
      locations: "Emplacements",
      cities: "Villes",
      regions: "Régions"
    },
    breadcrumbs: {
      countries: "Pays"
    }
  },

  // Regions section
    regions: {
    title: "Régions",
    resourceSingular: "région",
    resourcePlural: "régions", 
    headings: {
      name: "Nom",
      status: "Statut",
      locations: "Emplacements",
      cities: "Villes",
      country: "Pays"
    },
    breadcrumbs: {
      regions: "Régions"
    }
  },

  // Map section
  map: {
    title: "Carte",
    breadcrumbs: {
      locations: "Emplacements"
    }
  },

  // Import section
  import: {
    title: "Import CSV",
    breadcrumbs: {
      locations: "Emplacements"
    },
    new: {
      title: "Importer des emplacements par CSV",
      description: "Téléchargez un modèle CSV d'exemple pour voir un exemple du format requis",
      sampleTemplate: "modèle CSV d'exemple",
      uploadAndContinue: "Télécharger et continuer",
      abortOnError: "Abandonner en cas d'erreur",
      abortOnErrorHelp: "S'il y a une erreur, l'importation sera abandonnée, l'erreur sera affichée et aucun emplacement ne sera importé.",
      needHelp: "Besoin d'aide pour importer des emplacements ?"
    },
    show: {
      title: "Import CSV",
      youCanLeavePage: "Vous pouvez quitter cette page",
      backgroundMessage: "Votre importation continuera de s'exécuter en arrière-plan",
      importProgress: "Progression de l'importation",
      imported: "Importé",
      suffix: "emplacements",
      importLog: "Journal d'importation",
      cancelImport: "Annuler l'importation",
      cancelConfirmation: {
        title: "Annuler l'importation",
        message: "Êtes-vous sûr de vouloir annuler ce travail d'importation ? Cette action ne peut pas être annulée.",
        note: "Note : Pour les travaux en cours, le travail devra se terminer et sera supprimé immédiatement après.",
        yesCancel: "Oui, annuler l'importation",
        noContinue: "Non, continuer l'importation"
      },
      report: "Rapport",
      failedLocations: "Emplacements échoués",
      uploadAnother: "Télécharger un autre CSV",
      backToLocations: "Retour aux emplacements",
      importSucceeded: "Importation réussie",
      importFailed: "Importation échouée"
    },
    messages: {
      uploadSuccess: "CSV téléchargé avec succès",
      uploadError: "Impossible de télécharger le CSV",
      pending: "L'importation n'a pas encore commencé",
      inProgress: "Importation en cours",
      completed: "Importation terminée",
      invalidHeader: "Les colonnes suivantes sont requises",
      invalidCsvFile: "Fichier CSV invalide",
      aborted: "Importation abandonnée",
      failed: "Importation échouée",
      cancelled: "Importation annulée"
    },
    errors: {
      csvTooLarge: "Le CSV est trop volumineux",
      languageNotEnabled: "La langue '{{language}}' n'est pas activée pour cette boutique. Veuillez l'activer dans Paramètres > Langues d'abord.",
      fieldNotTranslatable: "Le champ '{{field}}' n'est pas traduisible. Les champs traduisibles sont : {{fields}}",
      locationError: "Emplacement avec slug : {{slug}} - {{error}}",
      planLimit: "Vous avez atteint la limite de votre plan pour les emplacements"
    }
  },

  // Location form
    location: {
    index: {
      title: "Emplacements",
      addLocation: "Ajouter un emplacement",
      import: "Importer",
      noPrioritySet: "Aucune priorité définie",
      published: "Publié",
      draft: "Brouillon",
      resourceSingular: "emplacement",
      resourcePlural: "emplacements",
      headings: {
        name: "Nom",
        status: "Statut", 
        city: "Ville",
        region: "Région",
        country: "Pays",
        priority: "Priorité"
      }
    },
        form: {
      title: "Ajouter un emplacement",
      editTitle: "Modifier l'emplacement",
      basicInformation: "Informations de base",
      name: "Nom",
      namePlaceholder: "ex. Briques de Brian",
      nameHelpDefault: "Par défaut : {{defaultName}}",
      details: "Détails",
      description: "Description",
      descriptionPlaceholder: "Dites aux clients ce qui rend cet emplacement spécial",
      address: "Adresse",
      addressPlaceholder: "123 Rue Principale, Ville, Pays",
      addressLine1: "Ligne d'adresse 1",
      addressLine2: "Ligne d'adresse 2",
      postalZipCode: "Code postal / ZIP",
      city: "Ville",
      stateProvinceRegion: "État / Province / Région",
      country: "Pays",
      phone: "Téléphone",
      phonePlaceholder: "+1 (555) 123-4567",
      email: "Email", 
      emailPlaceholder: "magasin@exemple.com",
      website: "Site web",
      websitePlaceholder: "https://www.exemple.com",
      image: "Image",
      imagePlaceholder: "Entrez l'URL de l'image",
      status: "Statut",
      statusActive: "Actif",
      statusInactive: "Inactif",
      statusDraft: "Brouillon",
      priority: "Priorité",
      priorityHelpText: "Les emplacements de priorité plus élevée apparaissent en premier dans les résultats de recherche",
      findOnMapButton: "Trouver sur la carte"
    },
        validation: {
      addressNotFound: "Impossible de trouver l'adresse",
      createSuccess: "Emplacement créé avec succès", 
      updateSuccess: "Emplacement mis à jour avec succès",
      checkFields: "Veuillez vérifier vos champs",
      findOnMap: "Veuillez trouver votre emplacement sur la carte avant d'enregistrer"
    },
    errors: {
      loading: "Erreur lors du chargement de l'emplacement"
    },
    actions: {
      save: "Enregistrer l'emplacement",
      delete: "Supprimer l'emplacement",
      preview: "Aperçu"
    },
    customFields: {
      title: "Champs personnalisés",
      noCustomFields: "Aucun champ personnalisé configuré",
      configureFields: "Configurer les champs",
      emptyState: "Vous n'avez pas encore configuré de champs personnalisés. Les champs personnalisés vous permettent d'ajouter des informations supplémentaires spécifiques aux besoins de votre entreprise."
    },
        openingHours: {
      title: "Heures d'ouverture",
      checkboxLabel: "Cet emplacement a des heures d'ouverture et de fermeture",
      statusOpen: "Ouvert",
      statusOpen24h: "Ouvert 24H",
      statusClosed: "Fermé",
      openingTimeLabel: "Heure d'ouverture",
      closingTimeLabel: "Heure de fermeture",
      days: {
        monday: "Lundi",
        tuesday: "Mardi", 
        wednesday: "Mercredi",
        thursday: "Jeudi",
        friday: "Vendredi",
        saturday: "Samedi",
        sunday: "Dimanche"
      }
    },
    table: {
      sortOptions: {
        recentlyAdded: "Recently added",
        recentlyModified: "Recently modified"
      },
      filters: {
        status: "Status",
        taggedWith: "Tagged with",
        locationStatus: "Location status",
        noTagsToShow: "No tags to show",
        searchPlaceholder: "Search"
      },
      bulkActions: {
        setPublished: "Set as published",
        setUnpublished: "Set as unpublished",
        setPriority: "Set priority",
        deleteLocations: "Delete locations",
        exportCSV: "Export as CSV"
      },
      appliedFilters: {
        statusIs: "Status is {{status}}",
        taggedWith: "Tagged with {{tag}}",
        nameIncludes: "Name includes {{search}}"
      },
      modals: {
        deleteTitle: "Supprimer les emplacements",
        deleteMessage: "Êtes-vous sûr de vouloir supprimer {{count}} ?",
        deleteMessageAll: "Êtes-vous sûr de vouloir supprimer tous les emplacements ?",
        prioritiseTitle: "Prioriser {{count}} emplacements",
        prioritiseTitleAll: "Prioriser tous les emplacements",
        delete: "Supprimer",
        cancel: "Annuler"
      },
      emptyState: {
        noResultsHeading: "Impossible de trouver {{resourcePlural}}",
        noResultsText: "Essayez de changer les filtres ou le terme de recherche",
        noDataHeading: "Ajoutez un emplacement pour remplir {{resourcePlural}}",
        addLocation: "Ajouter un emplacement",
        importFromCSV: "Importer depuis CSV"
      },
      pagination: {
        label: "Page {{page}} sur {{pages}}"
      },
      messages: {
        updatedSuccessfully: "Mis à jour avec succès",
        deletedSuccessfully: "Supprimé avec succès",
        exportedSuccessfully: "Exporté avec succès",
        error: "Quelque chose s'est mal passé"
      }
    }
  },

  // SEO Editor
  seo: {
    title: "Contenu de la page",
    editTemplate: "Modifier le modèle SEO",
    pageTitle: "Titre",
    pageDescription: "Description",
    metaTitle: "Titre",
    metaDescription: "Description",
    urlHandle: "Poignée URL",
    searchEnginePreview: "Aperçu de la liste de moteur de recherche",
    editMeta: "Modifier les métadonnées",
    previewMeta: "Aperçu des métadonnées",
    loading: "Chargement...",
    editingLocaleHelp: "Modification du contenu {{locale}}."
  },

  // SEO Templates section
  seoTemplates: {
    title: "Modèles SEO",
    breadcrumbs: {
      seoTemplates: "Modèles SEO"
    },
    template: {
      title: "Modèle {{templateName}} - {{locale}}",
      discardChanges: "Annuler les modifications"
    },
    form: {
      pageContent: "Contenu de la page",
      searchEnginePreview: "Aperçu de la liste de moteur de recherche",
      title: "Titre",
      description: "Description",
      pageTitle: "Titre de la page",
      metaDescription: "Description méta",
      editingLocaleHelp: "Modification des traductions {{locale}}. Les champs vides afficheront le contenu de {{defaultLocale}}.",
      defaultValue: "Par défaut : {{value}}"
    },
    language: {
      label: "Langue",
      defaultHelp: "C'est votre langue par défaut",
      editingHelp: "Modification des traductions {{locale}}. Les champs vides afficheront le contenu {{defaultLocale}}."
    },
    banner: {
      multipleLanguagesDisabled: "Langues multiples non activées",
      enableInSettings: "Activer dans les paramètres",
      multipleLanguagesInfo: "Pour gérer les modèles SEO pour plusieurs langues, activez l'internationalisation dans vos paramètres de langue. Affichage actuellement des modèles {{locale}} uniquement."
    },
    badges: {
      errors: "Erreurs !",
      unsaved: "Non enregistré"
    },
    messages: {
      saveSuccess: "Modèles SEO enregistrés avec succès",
      saveError: "Impossible d'enregistrer les modèles",
      error: "Erreur..."
    }
  },

  // Area form
  area: {
    form: {
      basicInformation: "Informations de base",
      name: "Nom",
      save: "Enregistrer",
      saving: "Enregistrement...",
      cancel: "Annuler",
      yourLocationsIn: "Vos emplacements dans {{name}}",
      tableHeadings: {
        name: "Nom",
        status: "Statut",
        city: "Ville",
        region: "Région",
        country: "Pays"
      },
      resourceName: {
        singular: "emplacement {{name}}",
        plural: "emplacements dans {{name}}"
      }
    }
  },

  // Settings section
  settings: {
    navigation: {
      map: "Carte",
      tags: "Étiquettes",
      customFields: "Champs personnalisés",
      languages: "Langues",
      plan: "Plan",
      addTag: "Ajouter une étiquette",
      addField: "Ajouter un champ"
    },
    planBadges: {
      trial: "!",
      endsSoon: "Se termine bientôt"
    },
    common: {
      loading: "Chargement...",
      error: "Erreur...",
      breadcrumbs: {
        settings: "Paramètres"
      },
      skeleton: {
        customFields: "Champs personnalisés",
        addField: "Ajouter un champ",
        name: "Nom",
        contentType: "Type de contenu",
        usedIn: "Utilisé dans",
        field: "Champ",
        fields: "Champs"
      },
      messages: {
        savedSuccessfully: "Paramètres {{setting}} enregistrés avec succès",
        couldntSave: "Impossible d'enregistrer les paramètres {{setting}}"
      }
    },
    map: {
      title: "Carte",
      messages: {
        savedSuccessfully: "Paramètres de carte enregistrés avec succès",
        couldntSave: "Impossible d'enregistrer les paramètres"
      },
      mapboxToken: {
        title: "Jeton Mapbox",
        description: "Entrez votre jeton Mapbox pour alimenter votre localisateur de magasins",
        label: "Jeton Mapbox",
        placeholder: "Entrez le jeton ici pour continuer à utiliser votre carte.",
        placeholderManaged: "Entrez le jeton ici pour continuer à utiliser votre carte une fois que vous aurez épuisé vos chargements de carte gratuits.",
        helpText: "Suivez nos instructions pour créer une clé Mapbox, puis collez votre clé ci-dessus. Si vous rencontrez des problèmes, veuillez nous contacter pour obtenir de l'aide.",
        linkInstructions: "instructions pour créer une clé Mapbox",
        linkSupport: "nous contacter pour obtenir de l'aide"
      },
      managedToken: {
        title: "Chargements de carte",
        description: "Vous avez jusqu'à {{max}} chargements de carte gratuits avec un jeton géré, après quoi vous devrez créer votre propre jeton."
      },
      appearance: {
        title: "Apparence",
        description: "Changez l'apparence de votre carte"
      },
      mapStyle: {
        title: "Style de carte",
        options: {
          streets: "Rues",
          outdoors: "Extérieur",
          light: "Clair",
          dark: "Sombre",
          satellite: "Satellite",
          satelliteStreets: "Rues satellite",
          navigationDay: "Navigation jour",
          navigationNight: "Navigation nuit"
        }
      },
      searchBehaviour: {
        title: "Comportement de recherche",
        description: "Contrôle comment les visiteurs trouvent les emplacements sur votre carte.",
        geolocateLabel: "Estimer automatiquement l'emplacement du visiteur et afficher les magasins à proximité",
        geolocateHelp: "Si la géolocalisation réussit, la carte se déplacera pour se concentrer près du visiteur. Si un emplacement estimé ne peut pas être trouvé, la carte restera à la position de départ.",
        filterBehaviour: {
          title: "Comportement du filtre",
          all: {
            label: "Toutes les étiquettes",
            help: "Pour qu'un emplacement apparaisse dans les filtres, il doit avoir toutes les étiquettes sélectionnées"
          },
          any: {
            label: "N'importe quelle étiquette",
            help: "Pour qu'un emplacement apparaisse dans les filtres, il peut avoir n'importe laquelle des étiquettes sélectionnées"
          }
        },
        keepSearchInView: {
          label: "Garder le marqueur de recherche en vue",
          help: "Lorsque les résultats de recherche apparaissent, la carte s'éloignera pour montrer tous les emplacements correspondants"
        },
        distanceUnits: {
          title: "Unités de distance",
          km: "Kilomètres",
          miles: "Miles"
        },
        maxResults: {
          label: "Résultats max",
          help: "Limiter le nombre d'emplacements affichés dans les résultats de recherche",
          options: {
            results30: "30 résultats"
          }
        },
        maxDistance: {
          label: "Distance max",
          help: "Afficher uniquement les emplacements dans cette distance du point de recherche",
          options: {
            unlimited: "Illimité"
          }
        },
        showLocationNames: {
          label: "Afficher les noms d'emplacements dans les suggestions",
          help: "Afficher les noms d'emplacements dans les suggestions de recherche"
        },
        sortByPriority: {
          label: "Trier par priorité au lieu de la distance",
          help: "Il est fortement recommandé de définir une distance maximale (qui ne soit pas Illimité) si cette case est cochée. Sinon, vos clients verront des emplacements éloignés qui ont une priorité élevée listés au-dessus de ceux qui sont à une distance raisonnable d'eux (ou de leur requête de recherche, plus précisément)."
        }
      },
      searchResults: {
        title: "Résultats de recherche",
        description: "Contrôle comment les emplacements sont retournés sur votre carte.",
        locationsLabel: "Texte des résultats de recherche",
        locationsHelp: "Texte affiché au-dessus des résultats de recherche (ex: 'Affichage de 5 emplacements')",
        prefixLabel: "Préfixe des résultats de recherche",
        prefixHelp: "Texte affiché avant le nombre de résultats"
      },
      popups: {
        title: "Fenêtres popup",
        showPopups: {
          label: "Afficher les fenêtres popup",
          help: "Afficher les détails de l'emplacement lorsque les visiteurs cliquent sur les marqueurs de carte"
        }
      },
      whitelabel: {
        title: "Marque blanche",
        hideLabel: "Masquer le texte 'propulsé par'",
        hideHelp: "Supprimer notre marque de votre localisateur de magasins"
      }
    },
    languages: {
      title: "Langues",
      error: "Erreur...",
      messages: {
        savedSuccessfully: "Paramètres de langue enregistrés avec succès",
        couldntSave: "Impossible d'enregistrer les paramètres de langue"
      },
      banner: {
        upgradeTitle: "La prise en charge multilingue nécessite une mise à niveau du plan",
        upgradeAction: "Passer à Superest",
        upgradeMessage: "Vous pouvez toujours changer votre langue par défaut, mais activer plusieurs langues nécessite une mise à niveau.",
        disabledMessage: "Les paramètres de langue multiple sont désactivés sur votre plan actuel"
      },
      defaultLanguage: {
        title: "Langue par défaut",
        description: "Choisissez votre langue principale dans laquelle votre contenu sera affiché.",
        label: "Langue par défaut",
        help: "Cette langue sera utilisée lorsqu'aucune langue spécifique n'est demandée"
      },
      internationalization: {
        title: "Internationalisation",
        description: "Activez plusieurs langues. Atteignez plus de clients et améliorez votre SEO.",
        enableLabel: "Activer plusieurs langues",
        enableHelp: "Permettre aux clients de voir votre localisateur de magasins dans différentes langues"
      },
      supportedLanguages: {
        title: "Langues supplémentaires prises en charge",
        description: "Sélectionnez les langues supplémentaires que vous souhaitez prendre en charge. Une fois que vous avez activé une langue, vous verrez l'option de fournir des traductions dans toute l'application. Pour les langues prises en charge, les modèles SEO par défaut, ainsi que les thèmes de variables communes seront générés automatiquement.",
        defaultLocaleNote: "Ceci est votre langue par défaut et ne peut pas être désactivée",
        shopifyEnabled: {
          label: "Cette langue est activée dans ma boutique Shopify",
          importantNote: "Important :",
          description: "Décochez la case ci-dessus si cette langue n'est pas activée et publiée pour votre boutique Shopify. Il est recommandé d'activer d'abord la langue pour votre boutique Shopify en allant dans Paramètres > Langues dans votre admin Shopify si vous ne l'avez pas déjà fait pour une meilleure expérience client."
        },
        urlFormats: {
          cleanUrls: "URLs propres :",
          betterSeo: "Meilleur SEO et expérience utilisateur",
          queryUrls: "URLs avec paramètres de requête :",
          considerEnabling: "Envisagez d'activer dans Shopify pour de meilleures URLs"
        },
        preview: {
          button: "Aperçu",
          tooltip: "Aperçu du localisateur de magasins {{language}}"
        },
        tooltips: {
          noTemplates: "Aucun modèle SEO par défaut disponible pour cette langue. Vous pouvez créer facilement des traductions personnalisées."
        }
      }
    },
    tags: {
      title: "Étiquettes",
      addTag: "Ajouter une étiquette",
      error: "Erreur",
      messages: {
        deletedSuccessfully: "Étiquettes supprimées avec succès",
        couldntDelete: "Les étiquettes n'ont pas pu être supprimées",
        savedSuccessfully: "Étiquette enregistrée avec succès",
        couldntSave: "Veuillez vérifier vos champs",
        tagDeleted: "Étiquette supprimée avec succès"
      },
      resourceName: {
        singular: "étiquette",
        plural: "étiquettes"
      },
      filters: {
        anyGroup: "N'importe quel groupe",
        inGroup: "Dans le groupe",
        tagGroup: "Groupe d'étiquettes"
      },
      appliedFilters: {
        inGroup: "Dans le groupe {{group}}",
        nameContains: "Le nom de l'étiquette contient {{query}}"
      },
      bulkActions: {
        deleteTag: "Supprimer l'étiquette",
        deleteTags: "Supprimer les étiquettes"
      },
      form: {
        language: "Langue",
        title: "Titre",
        description: "Description",
        group: "Groupe",
        groupPlaceholder: "Sélectionner un groupe",
        addGroup: "Ajouter",
        editingTranslations: "Modification des traductions {{language}}. Les champs vides afficheront le contenu de {{defaultLanguage}}.",
        defaultValue: "Par défaut : {{value}}",
        image: "Image",
        imageUrl: "URL de l'image"
      },
      actions: {
        save: "Enregistrer",
        deleteTag: "Supprimer l'étiquette"
      },
      new: {
        title: "Ajouter une étiquette",
        messages: {
          createSuccess: "Étiquette créée avec succès",
          checkFields: "Veuillez vérifier vos champs"
        },
        actions: {
          createTag: "Créer l'étiquette"
        }
      }
    },
    customFields: {
      title: "Champs personnalisés",
      addField: "Ajouter un champ",
      error: "Erreur",
      resourceName: {
        singular: "Champ",
        plural: "Champs"
      },
      headings: {
        name: "Nom",
        contentType: "Type de contenu",
        usedIn: "Utilisé dans"
      },
      emptyState: {
        heading: "Créez et gérez vos champs personnalisés",
        createAction: "Créer un champ",
        description: "Utilisez des champs personnalisés pour des attributs uniques concernant vos emplacements. Ces champs peuvent être n'importe quoi, des profils sociaux au nom et email du gestionnaire de magasin"
      },
      pluralization: {
        location: "emplacement",
        locations: "emplacements"
      },
      form: {
        name: "Nom",
        contentType: "Type de contenu",
        key: "Clé",
        keyPrefix: "location.fields.",
        keyHelp: "Utilisez cette clé pour accéder au contenu {{name}} d'un emplacement dans vos modèles liquid.",
        translations: {
          title: "Traductions",
          showTranslations: "Afficher les traductions",
          hideTranslations: "Masquer les traductions",
          description: "Les traductions sont optionnelles. Les champs vides afficheront le nom du champ {{language}}.",
          nameTranslation: "Nom ({{language}})",
          defaultValue: "Par défaut : {{value}}"
        }
      },
      messages: {
        savedSuccessfully: "Champ enregistré avec succès",
        couldntSave: "Le champ n'a pas pu être enregistré",
        deletedSuccessfully: "Champ supprimé avec succès",
        couldntDelete: "Le champ n'a pas pu être supprimé"
      },
      actions: {
        delete: "Supprimer"
      },
      new: {
        title: "Ajouter un champ",
        messages: {
          savedSuccessfully: "Champ enregistré avec succès",
          couldntSave: "Le champ n'a pas pu être enregistré"
        }
      },
      contentTypes: {
        text: "Texte",
        textArea: "Zone de texte",
        email: "Email",
        number: "Nombre",
        phoneNumber: "Numéro de téléphone",
        time: "Heure",
        url: "URL"
      }
    },
    plan: {
      title: "Plan",
      error: "Erreur",
      changePlan: "Changer de plan",
      usdPerMonth: "USD / mois",
      sections: {
        yourPlanIncludes: "Votre plan inclut",
        nextBillingDate: "Prochaine date de facturation",
        trial: "Essai"
      },
      banners: {
        planUpdated: "Votre plan a été mis à jour",
        thankYouUpgrading: "Merci pour la mise à niveau !",
        letUsKnow: "Faites-nous savoir",
        improvementText: "s'il y a quelque chose que nous pouvons améliorer."
      },
      locations: {
        upTo: "Jusqu'à",
        locations: "emplacements",
        unlimited: "Emplacements illimités",
        used: "utilisé",
        ofUsed: "{{used}} sur {{max}} utilisé"
      },
      trial: {
        daysLeft: "{{days}} jours restants",
        daysUsed: "{{used}} sur {{total}} jours utilisés",
        selectPlan: "Sélectionner un plan",
        currentPlan: "Plan actuel",
        trialBadge: "Essai",
        currentBadge: "Actuel",
        yourTrialJustStarted: "Votre essai vient de commencer",
        trialEndsAfterToday: "Votre essai se termine après aujourd'hui",
        trialEndsTomorrow: "Votre essai se termine demain",
        daysLeftInTrial: "{{days}} jours restants dans votre essai",
        continueAddingLocations: "Continuez à ajouter des emplacements après {{date}} en sélectionnant un plan",
        selectPlanToday: "Veuillez sélectionner un plan aujourd'hui pour continuer à ajouter des emplacements"
      },
      footer: {
        description: "Gérez ou changez votre plan Locations So Super. Consultez nos",
        termsOfService: "conditions de service",
        and: "et",
        privacyPolicy: "politique de confidentialité"
      },
      features: {
        analytics: {
          title: "Analyses",
          description: "Découvrez comment les gens utilisent vos emplacements et où ils recherchent"
        },
        internationalization: {
          title: "Prise en charge multilingue",
          description: "Améliorez le SEO et atteignez plus de clients dans les marchés cibles en activant plusieurs langues"
        },
        customThemes: {
          editLiquid: {
            title: "Modifier les modèles liquid du thème",
            description: "Affichez les données d'emplacement comme vous le souhaitez avec accès aux modèles liquid du thème"
          },
          editStructuredData: {
            title: "Modifier les données structurées de l'entreprise",
            description: "Modifiez comment Google comprend les pages en modifiant vos données structurées"
          }
        }
      },
      edit: {
        title: "Changer de plan",
        allPlansInclude: "Tous les plans ci-dessus incluent",
        needingMoreLocations: "Besoin de plus d'emplacements ?",
        footerQuestion: "Avez-vous des questions avant de commencer ?",
        sendMessage: "envoyez-nous un message",
        allFeatures: {
          seoDirectory: {
            title: "Répertoire SEO et pages d'atterrissage",
            description: "Créez automatiquement un répertoire SEO de tous vos emplacements, villes et régions"
          },
          mapPage: {
            title: "Page de carte avec recherche et filtre",
            description: "Recherchez et filtrez tous vos emplacements sur une carte alimentée par Mapbox"
          },
          tags: {
            title: "Étiquettes",
            description: "Créez des étiquettes avec des images et des descriptions et regroupez-les"
          },
          openingHours: {
            title: "Heures d'ouverture",
            description: "Définissez et affichez les heures d'ouverture de vos emplacements"
          },
          mapStyles: {
            title: "Styles de carte",
            description: "Changez l'apparence des cartes avec plusieurs styles prédéfinis"
          },
          customFields: {
            title: "Champs personnalisés",
            description: "Ajoutez tous les nouveaux champs que vous voulez, des liens sociaux au gestionnaire de magasin"
          },
          csvUpload: {
            title: "Télécharger et exporter avec CSV",
            description: "Téléchargez et modifiez en masse vos emplacements."
          },
          richSnippets: {
            title: "Extraits enrichis",
            description: "Aidez Google à mieux comprendre les pages avec des données structurées d'entreprise locale"
          },
          directionsAndCalls: {
            title: "Itinéraires et appels",
            description: "Les visiteurs peuvent facilement obtenir des itinéraires et appeler les emplacements"
          },
          languageSupport: {
            title: "Prise en charge linguistique",
            description: "Changez la langue par défaut pour autre chose que l'anglais. Des modèles de traduction fournis pour 32 langues principales pour une configuration facile."
          }
        }
      },
      planCard: {
        bestToCustomize: "Best to customize",
        currentPlan: "Current plan",
        chooseThisPlan: "Choose this plan",
        locationsSection: "Locations",
        featuresSection: "Features",
        upTo: "Up to",
        locations: "locations",
        tooltipTooManyLocations: "You have too many locations and/or enabled languages for this plan."
      },
      confirmation: {
        error: "Error confirming plan"
      }
    }
  },

  // Themes section
  themes: {
    title: "Thèmes",
    currentTheme: {
      title: "Thème actuel",
      description: "C'est le thème que les clients voient lorsqu'ils visitent votre application d'emplacements."
    },
    themeLibrary: {
      title: "Bibliothèque de thèmes",
      description: "Gérez les thèmes de vos emplacements. Ajoutez et publiez des thèmes pour changer l'apparence de votre emplacement en ligne."
    },
    skeleton: {
      currentThemeDescription: "C'est le thème que vos clients voient lorsqu'ils utilisent votre application d'emplacements."
    },
    modal: {
      overrideTitle: "Remplacer le thème actuel ?",
      override: "Remplacer",
      cancel: "Annuler",
      undoWarning: "Cette action ne peut pas être annulée."
    },
    messages: {
      publishSuccess: "Thème publié avec succès",
      publishError: "Impossible de publier le thème",
      error: "Quelque chose s'est mal passé"
    },
    emptyStates: {
      settings: {
        heading: "Ce thème n'a pas de paramètres",
        description: "Créez des paramètres dans l'éditeur de modèles.",
        createSettings: "Créer des paramètres",
        upgradePlan: "Mettre à niveau le plan",
        upgradeRequired: "Mettez à niveau le plan pour créer des paramètres"
      },
      language: {
        heading: "Ce thème n'a pas de termes de langue",
        description: "Créez des termes de langue dans l'éditeur de modèles.",
        createLanguageTerms: "Créer des termes de langue",
        upgradePlan: "Mettre à niveau le plan",
        upgradeRequired: "Mettez à niveau le plan pour créer des termes de langue"
      }
    },
    templates: {
      categories: {
        templates: "Modèles",
        schemas: "Schémas",
        styles: "Styles",
        liquidReference: "Référence liquid"
      },
      items: {
        landing: "Accueil",
        directory: "Répertoire",
        country: "Pays",
        region: "Région",
        city: "Ville",
        location: "Emplacement",
        language: "Langue",
        settings: "Paramètres",
        stylesheet: "Feuille de style"
      },
      errors: {
        errorsInTemplate: "Erreurs dans le modèle",
        error: "Erreur"
      },
      badges: {
        errors: "Erreurs !",
        unsaved: "Non enregistré"
      },
      actions: {
        viewTheme: "Voir le thème",
        discard: "Annuler",
        save: "Enregistrer"
      }
    },
    language: {
      messages: {
        saveSuccess: "Traductions du thème enregistrées avec succès",
        saveError: "Le thème n'a pas pu être enregistré"
      },
      form: {
        language: "Langue",
        defaultLanguageHelp: "C'est votre langue par défaut",
        translationHelp: "Modification des traductions pour {{selectedLocale}}. Les champs vides afficheront le contenu de {{defaultLocale}} (votre langue par défaut)."
      },
      banner: {
        multipleLanguagesNotEnabled: {
          title: "Langues multiples non activées",
          action: "Activer dans les paramètres",
          description: "Pour gérer les traductions pour plusieurs langues, activez l'internationalisation dans vos paramètres de langue. Affichage actuellement des traductions {{locale}} uniquement."
        },
        translating: {
          title: "Traduction de {{from}} vers {{to}}",
          description: "Tout champ que vous laissez vide affichera automatiquement le contenu {{defaultLocale}} à vos clients. Traduisez uniquement les champs où vous voulez un contenu différent en {{selectedLocale}}."
        }
      },
      accessLanguageTerms: "Accédez aux termes de langue {{category}} dans liquid avec {{code}}",
      fields: {
        title: "Titre",
        description: "Description",
        heading: "En-tête",
        subheading: "Sous-titre",
        button_text: "Texte du bouton",
        link_text: "Texte du lien",
        placeholder: "Espace réservé",
        label: "Étiquette",
        help_text: "Texte d'aide",
        error_message: "Message d'erreur",
        success_message: "Message de succès",

        // Opening hours
        Monday: "Lundi",
        Tuesday: "Mardi",
        Wednesday: "Mercredi",
        Thursday: "Jeudi",
        Friday: "Vendredi",
        Saturday: "Samedi",
        Sunday: "Dimanche",
        opening_hours_format: "Format d'heures d'ouverture",
        closes_at_format: "Fermeture à format",
        opens_at_format: "Ouverture à format",
        opens_on: "Ouverture le",
        open_24h: "Ouvert 24h",
        open: "Ouvert",
        closed: "Fermé",
        closes_at: "Fermeture à",
        opens_at: "Ouverture à",

        // Map
        search_map: "Rechercher sur la carte",
        search_area: "Rechercher dans cette zone",
        view_map: "Carte",
        view_list: "Liste",
        open_filters: "Filtres",
        stores_near_you: "Magasins à proximité",
        header: "Trouvez un magasin !",
        search_placeholder: "Tapez un code postal ou une adresse...",
        no_listings: "Désolé, nous ne trouvons pas de localisations pour votre recherche. Essayez de changer les filtres ou la localisation de recherche",

        // Directory
        view_directory: "Répertoire de magasins",

        // Location
        get_directions: "Itinéraires",
        call: "Appeler",
        view_website: "Site web",
        email: "Email",
        opening_hours_header: "Heures d'ouverture",
        description_header: "Informations",
        phone_number_header: "Téléphone",
        address_header: "Adresse",
        tag_groups_to_display: "Groupes d'étiquettes à afficher"
      },
      categories: {
        // Common language categories - add specific ones as needed
        general: "Général",
        navigation: "Navigation",
        forms: "Formulaires",
        buttons: "Boutons",
        messages: "Messages",
        errors: "Erreurs",
        opening_hours: "Heures d'ouverture",
        map: "Carte",
        directory: "Répertoire",
        location: "Emplacement"
      }
    },
    settings: {
      messages: {
        saveSuccess: "Thème enregistré avec succès",
        saveError: "Le thème n'a pas pu être enregistré"
      },
      accessSettings: "Accédez aux paramètres {{category}} dans liquid avec {{code}}",
      fields: {
        // Colors
        color_text: "Couleur du texte",
        color_text_heading: "Couleur du titre du texte",
        color_background: "Couleur de fond",
        color_accent: "Couleur d'accent",
        color_text_positive: "Couleur du texte positif",
        color_text_negative: "Couleur du texte négatif",
        dark_theme: "Thème sombre",
        color_marker: "Couleur du marqueur",
        color_search_marker: "Couleur du marqueur de recherche",

        // Typography
        base_font_size: "Taille de police de base",

        // Buttons
        border_radius: "Rayon de bordure",

        // Images
        aspect_ratio: "Ratio d'aspect",
        fit: "Ajuster",

        // Spacing
        page_width: "Largeur de la page",
        page_width_small: "Petite largeur de page",
        gutter_desktop: "Marge intérieure sur ordinateur",
        gutter_mobile: "Marge intérieure sur mobile",
        desktop_vertical_spacing: "Espacement vertical sur ordinateur",
        mobile_vertical_spacing: "Espacement vertical sur mobile",

        // Breakpoints
        breakpoint_xs: "Point de rupture XS",
        breakpoint_sm: "Point de rupture SM",
        breakpoint_md: "Point de rupture MD",

        // Map
        search_on_move: "Rechercher lors du déplacement",
        scroll_to_zoom: "Faire défiler pour zoomer",

        // Landing page
        sidebar_width: "Largeur de la barre latérale",
        sidebar_min_height: "Hauteur minimale de la barre latérale",
        marker_image_src: "Source de l'image du marqueur",
        show_filter_descriptions: "Afficher les descriptions des filtres",

        // Location page
        tag_groups_to_display: "Groupes d'étiquettes à afficher",
        tag_groups_to_display_as_icons: "Groupes d'étiquettes à afficher comme icônes",
        show_related_locations: "Afficher les emplacements associés",

        // Locations
        hide_regions: "Masquer les régions"
      },
      categories: {
        colors: "Couleurs",
        typography: "Typographie",
        buttons: "Boutons",
        images: "Images",
        spacing: "Espacement",
        breakpoints: "Points de rupture",
        map: "Carte",
        landing_page: "Page d'accueil",
        location_page: "Page d'emplacement",
        locations: "Emplacements"
      }
    },
    navigation: {
      sublimeTheme: "Thème Sublime",
      settings: "Paramètres",
      language: "Langue",
      templates: "Modèles",
      changeTheme: "Changer de thème",
      viewDirectory: "Voir le répertoire",
      viewLandingPage: "Voir la page d'accueil"
    },
    card: {
      lastUpdated: "Dernière mise à jour",
      view: "Voir",
      customize: "Personnaliser",
      publish: "Publier",
      actions: "Actions"
    }
  },

  // Analytics section
  analytics: {
    title: "Analyses",
    timePeriods: {
      last7days: "7 derniers jours",
      last30days: "30 derniers jours"
    },
    comparison: {
      compareToPrevious: "Comparer à la période précédente",
      stopComparing: "Arrêter de comparer à la période précédente"
    },
    sections: {
      searchLocations: "Rechercher des emplacements"
    },
    cards: {
      sessions: "Sessions",
      topSearches: "Meilleures recherches",
      topLandingPageType: "Type de page d'atterrissage principal",
      topPageViewsBySession: "Pages vues principales par session",
      topLocations: "Emplacements principaux",
      topReferrers: "Principaux référents",
      searches: "Recherches",
      topLandingPagesBySession: "Pages d'atterrissage principales par session"
    },
    chartLabels: {
      desktop: "Ordinateur"
    }
  },

}; 